/**
 * DailyObjectivePlaceholder Widget
 *
 * Placeholder for the Daily Objective banner widget.
 * Future WU provides real objective data from the Pre-Trading phase.
 *
 * @see types/shared/BannerWidget.ts — BannerWidgetComponentProps contract
 * @see widgetComponentRegistry.ts — component mapping
 */

import React from 'react';
import { Target } from 'lucide-react';

import type { BannerWidgetComponentProps } from '@/types/shared/BannerWidget';

export const DailyObjectivePlaceholder: React.FC<BannerWidgetComponentProps> = () => {
  return (
    <div className="flex items-center gap-1.5 text-xs text-default-400 whitespace-nowrap">
      <Target size={14} className="shrink-0" />
      <span>Daily objective — coming soon</span>
      <span className="hidden md:inline text-default-300">|</span>
      <span className="hidden md:inline text-[11px] text-default-300">Set objectives in Pre-Trading</span>
    </div>
  );
};
